import { render, staticRenderFns } from "./aufgaben_table_bauhof.vue?vue&type=template&id=a228b936&scoped=true"
import script from "./aufgaben_table_bauhof.vue?vue&type=script&lang=js"
export * from "./aufgaben_table_bauhof.vue?vue&type=script&lang=js"
import style0 from "./aufgaben_table_bauhof.vue?vue&type=style&index=0&id=a228b936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a228b936",
  null
  
)

export default component.exports